<!--个人备课-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <div class="filter-group">
                    <div class="filter-item">
                        <span class="filter-label">学段</span>
                        <el-select class="filter-select" clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">年级</span>
                        <el-select class="filter-select" clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">学科</span>
                        <el-select class="filter-select" clearable @change="pageUserLesson(null)" v-model="queryParams.subjectKey" placeholder="请选择">
                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">状态</span>
                        <el-select class="filter-select" clearable @change="pageUserLesson(null)" v-model="queryParams.status" placeholder="请选择">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                       :value="item.value" />
                        </el-select>
                    </div>
                </div>
                <div class="search-group">
                    <el-input class="search-input" v-model="queryParams.title" placeholder="请输入关键词" clearable
                              @keyup.enter="pageUserLesson(null)">
                        <template #append>
                            <el-button class="search-btn" @click="pageUserLesson(null)">
                                <el-icon><Search /></el-icon>
                            </el-button>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewLesson(item)">
                                    <div class="course-name">{{item.title}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.coverUrl" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="sub-info">{{item.periodName}}-{{item.gradeName}}-{{item.subjectName}}</div>
                                                <div class="status-info" v-if="item.status===1">初始</div>
                                                <div class="status-info-fb" v-if="item.status===9">备课完成</div>
                                            </div>
                                            <div class="course-commend">主备人:{{item.leadUserName}}</div>
                                            <div class="course-commend">课题级别:{{item.lessonLevelName}}</div>
                                            <div class="course-commend">备课时间:{{ timestampToTime(item.createTime) }}</div>
                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageUserLesson" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情编辑模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <pre-lesson-info :lesson-id="this.lessonId"/>
        </div>
        <!-- 新增模式 -->
        <div class="detail-mode" v-if="showMode==='add'">
            <add-pre-lesson @change-show="changeShow"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {lessonPageLessons} from "@/api/admin/lesson";
import PreLessonInfo from "@/components/eduResearch/preLessonInfo.vue";
import addPreLesson from "@/components/eduResearch/AddPreLesson.vue";

export default {
    name:'eduUserLesson',
    components:{PreLessonInfo, pageTag, dataEmpty,addPreLesson},
    props:{
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageUserLesson();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        this.getQueryDict();
        this.pageUserLesson();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'高水平示范课',
            itemKey:'',
            queryParams: {
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                pageNum: 1,
                pageSize: 9,
                type:1
            },
            total: 0,
            pageCount:0,
            dataList: [],
            lessonId:'',
            periodList: [],
            gradeList: [],
            subjectList: [],
            statusList: [
                { name: '初始', value: 1 },
                { name: '备课完成', value: 9 },
            ],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageUserLesson()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.pageUserLesson()
        },
        pageUserLesson(){
            lessonPageLessons(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;

            });
        },
        viewLesson(item){
            this.showMode = "detail"
            this.lessonId = item.lessonId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
        addLesson(){
            this.showMode = "add";
            this.$emit('change-mode',this.showMode);
        },
        changeShow(item){
            this.pageUserLesson()
            this.showMode = item;
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    border-radius: 28px;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
/* 搜索条件 */
.form-box{
    width: 100%;
    min-height: 70px;
    flex-shrink: 0;
    border-bottom: 2px solid #ff7f2e;
    background-color: #fff;
    padding: 10px 20px;
    box-sizing: border-box;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}
.filter-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}
.filter-item{
    display: flex;
    align-items: center;
    gap: 6px;
}
.filter-label{
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}
.filter-select{
    width: 120px;
}
.search-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-left: auto;
}
.search-input{
    width: 240px;
}
.search-btn{
    background-color: #ff7f2e;
    color: #fff;
}
.search-btn:hover,
.search-btn:focus{
    background-color: #0b4a8f;
    color: #fff;
}
::v-deep .search-input .el-input-group__append{
    background-color: #ff7f2e;
    box-shadow: none;
}
.right-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
}
.page-info-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #fff;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
}
.info-list-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-top: 15px;
    padding-left: 15px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-right: 15px;
    padding-bottom: 15px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 15px;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
    padding-top: 10px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 42px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    height: 30px;
    display: flex;
    align-items: center;
}
.sub-info{
    flex: 1;
    min-width: 0;
    color: #333333;
    height: 30px;
    line-height: 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.status-info{
    flex-shrink: 0;
    min-width: 64px;
    height: 24px;
    line-height: 24px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #409eff;
    font-size: 12px;
    text-align: center;
    color: #fff;
}
.status-info-fb{
    flex-shrink: 0;
    min-width: 64px;
    height: 24px;
    line-height: 24px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #3db8a4;
    font-size: 12px;
    text-align: center;
    color: #fff;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>
